//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $ from 'jquery';
export default {
    data() {
            return {
                telephone: '',
                password: '',
                repassword: '',
                nickname: '',
                imgurl: '',
                dialog: false,
                openCon: '',
                picImg: false,
                data: ''
            }
        },
        mounted() {
            this.$store.state.sildeShow = false;
        },
        methods: {
            open() {
                this.dialog = true
            },
            close() {
                this.dialog = false
            },
            //点击注册
            gotoRegister() {
                this.open();
                //匹配输入框信息
                var inputCon = document.getElementsByClassName("mu-text-field-input");
                var imgurl = document.querySelector('#uploadForm input').files;
                //获取手机号
                //console.log(inputCon[0].value);
                var _telephone = inputCon[0].value;
                //console.log(_telephone)
                this.telephone = _telephone
                    //console.log(this.telephone)
                if (!/^1[3-57-9]\d{9}$/.test(_telephone)) {
                    this.openCon = '您输入的手机号不正确！请重新输入正确的手机号';
                    return false;
                }
                //获取昵称
                var _nickname = inputCon[1].value;
                //console.log(_nickname)
                this.nickname = _nickname;
                if (!/^([\u2E80-\u9FFF]*)|[a-zA-Z]*$/.test(_nickname)) {
                    this.openCon = '您的输入不符合规则，请输入中/英文的昵称';
                    return false;
                }
                //获取首次密码值
                var _password = inputCon[2].value;
                //console.log(_password);
                this.password = _password;
                //console.log(this.password)
                if (!/^\S{6,20}$/.test(_password)) {
                    this.openCon = '密码不合法,请输入6-20位的密码';
                    return false;
                }
                //确认密码
                var _repassword = inputCon[3].value;
                //console.log(_repassword);
                this.repassword = _repassword;
                //console.log(this.repassword)
                if (_repassword !== _password) {
                    this.openCon = '两次输入密码不一致';
                    return false;
                }
                //发送ajax请求
                this.sendReg();
            },
            sendReg() {
                this.$ajax({
                        url: 'http://localhost:12345/register',
                        params: {
                            telephone: this.telephone,
                            nickname: this.nickname,
                            password: this.password,
                            repassword: this.repassword
                        }
                    })
                    .then((res) => {
                        var inputCon = document.getElementsByClassName("mu-text-field-input");
                        this._telephone = inputCon[0].value;
                        this._password = inputCon[1].value;
                        console.log(this._telephone, this._password);
                        //将用户名存入cookie
                        document.cookie = 'tel=' + this._telephone;
                        //console.log(res);
                        //this.openCon = '注册成功，前往登录';
                        //location.href = '#/login';
                        var cookies = document.cookie;
                        if (cookies) {
                            console.log(666, cookies)
                            var arr = cookies.split('; ');
                            arr.forEach(function(item) {
                                var temp = item.split('=');
                                location.href = '/';
                            })
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        this.openCon = '蓝瘦，注册不幸失败了，请重新注册';
                    });
            },
            doUpload() {
                var dd = new FormData($('#uploadForm')[0]);
                var _self = this;
                console.log(dd)
                console.log(_self)
                dd.append('headpic', document.querySelector('#uploadForm input').files[0]);
                console.log(document.querySelector('#uploadForm input').files);
                $.ajax({
                    url: 'http://localhost:12345/upload-single',
                    type: 'POST',
                    cache: false, //不必须
                    data: dd,
                    processData: false,
                    contentType: false,
                    success: function(data) {
                        console.log(_self.telephone)
                        console.log(data)
                        $(".headpic").attr("src", "../../static/uploads/" + data);
                        //console.log($(".headpic").attr("src", "../../static/uploads/" + data));
                        console.log($(".headpic").attr("src", "../../static/uploads/" + data)[0].src);
                        var imgurl = $(".headpic").attr("src", "../../static/uploads/" + data)[0].src;
                        //console.log(imgurl)
                        //console.log(_self.imgurl)
                        _self.$ajax({
                                url: 'http://localhost:12345/touxiang',
                                params: {
                                    telephone: _self.telephone,
                                    imgurl: imgurl
                                }
                            })
                            .then((res) => {
                                console.log(res);
                                console.log(6666, res.config.params.imgurl)
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    }
                });
            },
            uploadImg() {
                console.log(123);
                $("#uploadForm input").trigger('click');
            }
        }

}



// WEBPACK FOOTER //
// ./src/components/xregister.vue